/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PhrBloodPressureTimes,
  PhrBloodPressureTimesFromJSON,
  PhrBloodPressureTimesFromJSONTyped,
  PhrBloodPressureTimesToJSON,
} from "./";

export const PhrBloodPressuresTypename = "PhrBloodPressures" as const;

/**
 *
 * @export
 * @interface PhrBloodPressures
 */
export interface PhrBloodPressures {
  /**
   *
   * @type {PhrBloodPressureTimes}
   * @memberof PhrBloodPressures
   */
  dbp?: PhrBloodPressureTimes;
  /**
   *
   * @type {PhrBloodPressureTimes}
   * @memberof PhrBloodPressures
   */
  sbp?: PhrBloodPressureTimes;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrBloodPressures
   */
  readonly __typename?: string;
}

export function PhrBloodPressuresFromJSON(json: any): PhrBloodPressures {
  return PhrBloodPressuresFromJSONTyped(json, false);
}

export function PhrBloodPressuresFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrBloodPressures {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrBloodPressuresTypename,

    dbp: !exists(json, "dbp") ? undefined : PhrBloodPressureTimesFromJSON(json["dbp"]),
    sbp: !exists(json, "sbp") ? undefined : PhrBloodPressureTimesFromJSON(json["sbp"]),
  };
}

export function PhrBloodPressuresToJSON(object?: PhrBloodPressures | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    dbp: PhrBloodPressureTimesToJSON(value.dbp),
    sbp: PhrBloodPressureTimesToJSON(value.sbp),
  };
}
